import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from 'src/app/globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http:HttpClient) { }
 

  addUser(body):Observable<any>{
    let headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.post<any>(Globals.Url + 'User/SignUp',JSON.stringify(body),{headers:headers})
  }

  UAEPASSProfile(code: string, state: string): Observable<any> {
    //const apiUrl = `${Globals.Url}PortalUserUnified/GetUAEPassProfile?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
    const apiUrl = `${Globals.Url}PortalUserUnified/GetUAEPassProfileForProd?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
    return this.http.get<any>(apiUrl);
  }

  UpdateUserForUAEPass(body):Observable<any>{
    let headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.post<any>(Globals.Url + 'PortalUserUnified/UpdateUserCredential',JSON.stringify(body),{headers:headers})
  }
  // UpdateUserForUAEPass(body: any): Observable<any> {
  //   const apiUrl = `${Globals.Url}PortalUserUnified/UpdateUserCredential`;
  //   return this.http.post<any>(apiUrl, body);
  // }
  
}
